import React, { useEffect, useState } from 'react';
import api from '../../lib/api';

/**
 * DeploymentHistory — list of every production deploy recorded by
 * `deploy.sh`. Each entry shows sha, prev_sha, status, and notes.
 */
export default function DeploymentHistory() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get('/lab/deployments').then(({ data }) => setData(data)).catch(() => {});
  }, []);

  if (!data) return <div className="p-4 text-[11px] text-[var(--txt-secondary)]">loading…</div>;
  const deploys = data.deploys || [];

  return (
    <div data-testid="lab-deployments" className="space-y-3">
      <div className="text-[10px] tracking-[0.25em] uppercase text-[var(--txt-secondary)]">
        {data.count} deployments recorded
      </div>
      {deploys.length === 0 ? (
        <div className="border border-[var(--border-default)] p-4 text-[11px] text-[var(--txt-secondary)]">
          No production deployments yet. After the next CI/CD run, deploy.sh
          will POST a record to /api/lab/deployments and entries will appear here.
        </div>
      ) : (
        <table className="w-full text-[10px] font-mono">
          <thead>
            <tr className="text-left text-[var(--txt-secondary)] uppercase tracking-[0.2em] text-[9px]">
              <th className="py-1 pr-3">sha</th>
              <th className="py-1 pr-3">prev</th>
              <th className="py-1 pr-3">status</th>
              <th className="py-1 pr-3">deployed</th>
              <th className="py-1 pr-3">by</th>
              <th className="py-1">notes</th>
            </tr>
          </thead>
          <tbody>
            {deploys.map((d) => (
              <tr key={d.id} data-testid={`lab-deploy-${d.id}`} className="border-t border-[var(--border-default)]">
                <td className="py-1 pr-3 text-cyan-sys">{d.sha}</td>
                <td className="py-1 pr-3 text-[var(--txt-secondary)]">{d.prev_sha || '—'}</td>
                <td className={`py-1 pr-3 uppercase tracking-[0.2em] ${
                  d.status === 'success' ? 'text-buy' :
                  d.status === 'failed'  ? 'text-sell' : 'text-hold'
                }`}>{d.status}</td>
                <td className="py-1 pr-3">{(d.deployed_at || '').replace('T', ' ').slice(0, 19)}</td>
                <td className="py-1 pr-3 text-[var(--txt-secondary)]">{d.author}</td>
                <td className="py-1 text-[var(--txt-secondary)]">{d.notes}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
